import(/* webpackMode: "eager" */ "/home/SILANGIT-FIX/fe-silangit-app-fix/src/app/pelatihan/error.jsx");
